<template id="keyword">
	<div class="page page-keyword">
		<page-top></page-top>
		<div class="page-content">
			
			<div class="left">
				<div class="heading">KEYWORD</div>
				<div class="nav">
					<div class="nav-item" v-for="(keyword, i) in keywords"><a v-on:click="goto(i)">&gt;&nbsp;{{keyword.title}}</a></div>
				</div>
			</div>
			<div class="right">
				
				<div class="keywords">
					<div class="keyword" v-bind:name="'keyword-' + i" v-for="(keyword, i) in keywords">
						<div class="horizontal-line">
							<div class="bg-left"></div>
							<div class="bg-center"></div>
							<div class="bg-right"></div>
						</div>
						<div class="title">{{keyword.title}}</div>
						<div class="content" v-if="keyword.picture">{{keyword.content}}</div>
						<div class="content-full" v-if="!keyword.picture">{{keyword.content}}</div>

						<div class="picture" v-if="keyword.picture">
							<div class="">
								<img v-bind:src="keyword.picture">
							</div>
						</div>
						
					</div>
				</div>
			</div>
		
		</div>

		<page-bottom></page-bottom>

	</div>
</template>

<script>
import $ from 'jquery'
export default {
	data: function() {
		return {
			keywords: global.keywords || []
		}
	},
	created() {

		if (!this.keywords.length) {
			this.axios.get('/keyword/getList').then((response) => {
				this.keywords = response.data
				global.keywords = response.data
			})
		}
	},
	methods: {
		goto: function(i) {
			$('body').animate({ scrollTop: $('[name="keyword-'+ i +'"]').offset().top - 20}, 600)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Keyword.vue